import { post } from '../base';

export function resetPassword(params: { email: string }): Promise<void | string> {
  return post('v4/password/reset', { json: params }).text();
}
